import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";
import style from "../AdminLayout.module.css";
import Seperator from "components/Separator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import Center from "layouts/wrapper/Center";
function AdminStoreRegister() {
    const inputs = useRef([]);
    const searchRef = useRef();
    const selectRef = useRef();
    const { t } = useTranslation();

    const id = 'root';
    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState();
    const [selectedVendorId, setSelectedVendorId] = useState();
    const [info, setInfo] = useState();
    /* 국내 주소 관련  */
    const [enroll_company, setEnroll_company] = useState({});
    /* 국내 주소 관련 끝 */
    const addressKrModalClick = () => {
        NiceModal.show("addressKr", { onCallback: addressKrCallback });
    }
    const addressKrCallback = (dataFromModal) => {
        const kakao = window.kakao;
        const geocoder = new kakao.maps.services.Geocoder();

        // 모달에서 받은 주소를 기반으로 좌표 검색
        geocoder.addressSearch(dataFromModal.address, function (result, status) {
            if (status === kakao.maps.services.Status.OK) {
                const { x, y } = result[0]; // 변환된 좌표

                // 좌표와 함께 info 상태 업데이트
                setInfo((prevInfo) => ({
                    ...prevInfo,
                    address: dataFromModal.address,
                    zonecode: dataFromModal.zonecode,
                    latitudeByX: y,
                    longitudeByY: x, //실제로 오는 값의 매핑과 변수명이 반대입니다 일단은 진행
                }));

                // enroll_company도 업데이트
                setEnroll_company((prevState) => ({
                    ...prevState,
                    address: dataFromModal.address,
                    zonecode: dataFromModal.zonecode,
                }));
            } else {
                console.error("주소 변환 실패:", status);
            }
        });
    };

    const signUp = () => {
        let data = { storeName: "", vendorId: "", address: "", latitudeByX: "", longitudeByY: "" }
        validateInputs(inputs.current).then((isValid) => {
            if (isValid) {
                // 유효성 검사를 통과하면, 입력 필드로부터 값을 가져와 data 객체를 업데이트
                data.storeName = inputs.current[0].getValue();
                data.storeCode = inputs.current[1].getValue();
                data.address = inputs.current[2].getValue();
                data.vendorId = selectedVendorId;
                data.latitudeByX = info.latitudeByX;
                data.longitudeByY = info.longitudeByY;
                if (!selectedVendorId) {
                    toast.error(t("점주를 선택해주세요"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                    return;
                } else {
                    dispatch(HistoryReducer.actions.setLoading(true));
                    requester.createStore(data, (result) => {
                        if (result.code === 0) {
                            toast.success(t("등록이 완료되었습니다."), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            })
                        } else {
                            toast.error(t("문제가 발생했습니다 관리자에게 문의하세요"), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                        dispatch(HistoryReducer.actions.setLoading(false));
                    });
                }

                // 이후 데이터 처리 로직...
            } else {
                toast.error(t("pleaseCheck"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });

            }
        })
    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    const search = () => {
        let data = { userName: searchRef.current.getValue() }
        requester.searchVendor(data, (result) => {
            setSearchResults(result.data);
        })

    }

    const handleSelectChange = (e) => {
        setSelectedVendorId(e.target.value); // 선택된 값으로 상태 업데이트
    };

    return (
        <Container>
            <div className={style.section}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <div>
                            <P size={20} font={"gmarketSansBold"} color={"black"}>스토어 기본정보</P>
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <Seperator color={"#bebebe"} height={"1px"} />
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} maxWidth={"100px"} >
                                <P>매장명</P>
                            </FlexChild>
                            <FlexChild maxWidth={"400px"}>
                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"매장명"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} maxWidth={"100px"}>
                                <P>점주찾기</P>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={10} alignItems={"flex-start"} justifyContent={"flex-start"}>
                                    <FlexChild maxWidth={"400px"}>
                                        <InputText ref={searchRef} placeHolder={"점주 ID 검색"} />
                                    </FlexChild>
                                    <FlexChild width={"initial"}>
                                        <div className={style.searchButton} onClick={search}>
                                            <SquareWrapper width={34.5}>
                                                <Center>
                                                    <FontAwesomeIcon fontSize={20} icon={fas["faSearch"]} color={"var(--main-color)"} />
                                                </Center>
                                            </SquareWrapper>
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {
                        searchResults &&
                        searchResults.length > 0 && (
                            <FlexChild flexStart>
                                <select onChange={handleSelectChange} ref={selectRef} value={selectedVendorId}>
                                    <option value={""}>선택하세요</option>
                                    {searchResults.map((vendor, index) => (
                                        <option key={index} value={vendor.id}>
                                            {vendor.userName}
                                        </option>
                                    ))}
                                </select>
                            </FlexChild>
                        )
                    }
                    <FlexChild>
                        <HorizontalFlex gap={30} flexStart>
                            <FlexChild width={"20%"} maxWidth={"100px"}>
                                <P>주소</P>
                            </FlexChild>
                            <FlexChild >
                                <HorizontalFlex gap={10} alignItems={"flex-start"} justifyContent={"flex-start"}>
                                    <FlexChild maxWidth={"400px"}>
                                    <InputText
                                            value={info ? `${info?.address + (info.zonecode ? `(${info.zonecode})` : "")}` || `${enroll_company.address} (${enroll_company.zonecode})` || "" : ""}
                                            ref={el => (inputs.current[2] = el)}
                                            placeHolder={"주소"}
                                        />
                                    </FlexChild>
                                    <FlexChild width={"initial"}>
                                        <div className={style.searchButton} onClick={addressKrModalClick}>
                                            <SquareWrapper width={34.5}>
                                                <Center>
                                                    <FontAwesomeIcon fontSize={20} icon={fas["faSearch"]} color={"var(--main-color)"} />
                                                </Center>
                                            </SquareWrapper>
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>

                               
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} maxWidth={"100px"}>

                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex flexStart >
                                    <FlexChild>
                                        <Inline>
                                            <P>위도 : </P>
                                            <P>{info?.latitudeByX}</P>
                                        </Inline>
                                    </FlexChild>
                                    <FlexChild>
                                        <Inline>
                                            <P>경도 : </P>
                                            <P>{info?.longitudeByY}</P>
                                        </Inline>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} maxWidth={"100px"}>
                                <P>상점 코드</P>
                            </FlexChild>
                            <FlexChild maxWidth={"400px"}>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"상점코드"} regExp={[textFormat]} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <CustomButton text={"점주등록"} style={btnStyle} onClick={signUp} />
                    </FlexChild>
                </VerticalFlex>
            </div>
        </Container>
    );
}

export default AdminStoreRegister;